import { Button, Checkbox, Form, Row, Space, Typography } from 'antd';
import { useRouter } from 'next/router';
import { useLayoutEffect, useMemo, useState } from 'react';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EndUserRequestFormValues } from '../../../types/form';
import EndUserForm from '../../components/Forms/EndUserForm';
import SanitizedHtmlComponent from '../../components/SanitizedHtmlComponent';
import useEndUserFormById from '../../hooks/end-user-form/useEndUserFormById';
import EndUserRequestFieldsContainer from './EndUserRequestFieldsContainer';

const { Title, Text } = Typography;

const SubmitButton = () => {
    const { t } = useTranslation('forms');
    const {
        query: { userFormId }
    } = useRouter();

    const { data: selectedForm, isLoading } = useEndUserFormById(userFormId?.toString());
    const consentText = selectedForm?.consent;
    const [checked, setChecked] = useState(!consentText);

    const { isSubmitting } = useFormState<EndUserRequestFormValues>();

    const notValidFormId = useMemo(() => Number.isNaN(+userFormId), [userFormId]);
    useLayoutEffect(() => {
        if (!consentText) setChecked(true);
    }, [consentText]);

    return (
        <>
            {consentText && (
                <Form.Item>
                    <Checkbox checked={checked} onChange={() => setChecked(!checked)}>
                        <SanitizedHtmlComponent dirtyHtml={consentText} />
                    </Checkbox>
                </Form.Item>
            )}
            <Row justify="center" align="middle">
                <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: '50%' }}
                    disabled={isSubmitting || notValidFormId || !checked}
                    loading={isSubmitting || isLoading}
                >
                    {t('endUserForm.submit')}
                </Button>
            </Row>
        </>
    );
};

const EndUserFormContainer = () => {
    const { t } = useTranslation('forms');

    return (
        <EndUserForm>
            <Space direction="vertical" size="large" className="full-width">
                <Space direction="vertical" size="small" className="full-width">
                    <Title level={2} style={{ marginBottom: 0, marginBlockStart: 0 }}>
                        {t('endUserForm.title')}
                    </Title>
                    <Text type="secondary" style={{ marginBottom: 0 }}>
                        {t('endUserForm.description')}
                    </Text>
                </Space>

                <EndUserRequestFieldsContainer />
                <SubmitButton />
            </Space>
        </EndUserForm>
    );
};

export default EndUserFormContainer;
